import { render, staticRenderFns } from "./RoomGroup.vue?vue&type=template&id=2f23be2f&scoped=true"
import script from "./RoomGroup.vue?vue&type=script&lang=js"
export * from "./RoomGroup.vue?vue&type=script&lang=js"
import style0 from "./RoomGroup.vue?vue&type=style&index=0&id=2f23be2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f23be2f",
  null
  
)

export default component.exports